import { authApi } from '@/api'

const state = {
  user: null,
  token: localStorage.getItem('token') || null,
  userName: localStorage.getItem('userName') || '',
  userId: localStorage.getItem('user_id') || null,
  loading: false,
  error: null,
}

const getters = {
  isAuthenticated: (s) => !!s.token,
  currentUser: (s) => s.user,
}

const mutations = {
  SET_AUTH(state, { user, token }) {
    state.user = user
    state.token = token
    state.userName = user?.user_name || ''
    state.userId = user?.id || null
    localStorage.setItem('token', token)
    localStorage.setItem('userName', state.userName)
    localStorage.setItem('user_id', state.userId)
  },
  CLEAR_AUTH(state) {
    state.user = null
    state.token = null
    state.userName = ''
    state.userId = null
    localStorage.removeItem('token')
    localStorage.removeItem('userName')
    localStorage.removeItem('user_id')
  },
  SET_LOADING(state, val) { state.loading = val },
  SET_ERROR(state, val) { state.error = val },
}

const actions = {
  async login({ commit }, credentials) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const { data } = await authApi.login(credentials)
      commit('SET_AUTH', { user: data.data, token: data.token })
      return data
    } catch (e) {
      commit('SET_ERROR', e.response?.data?.message || 'Login failed')
      throw e
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async register({ commit }, payload) {
    commit('SET_LOADING', true)
    try {
      const { data } = await authApi.register(payload)
      commit('SET_AUTH', { user: data.user, token: data.token })
      return data
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async logout({ commit }) {
    try { await authApi.logout() } catch (_) { /* ignore */ }
    commit('CLEAR_AUTH')
  },
  async fetchUser({ commit, state }) {
    if (!state.token) return
    try {
      const { data } = await authApi.me()
      commit('SET_AUTH', { user: data, token: state.token })
    } catch (_) {
      commit('CLEAR_AUTH')
    }
  },
}

export default { namespaced: true, state, getters, mutations, actions }
